import { render, staticRenderFns } from "./IconPlusBold.vue?vue&type=template&id=3731e9a2"
import script from "./IconPlusBold.vue?vue&type=script&lang=js"
export * from "./IconPlusBold.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports